import React from 'react';
import './Footer.css';
import { Link } from 'gatsby';

const Footer = (props) => {
	return (
		<Link to="/contact/" className={`footer ${props.navOpen ? 'footer_open' : 'footer_close'}`}>
			<p>
				&copy;2019 Copyright by <span>MASU</span>, Zagreb, Croatia
			</p>
		</Link>
	);
};
export default Footer;
